import React from 'react';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { BaseButton } from './BaseButton';
import { BaseTypography } from '../BaseTypography/BaseTypography';
import clsx from 'clsx';

type TValue = any;
type TLabel = any;

interface IButton {
  value: TValue;
  label: string;
}

type PBaseButtonGroup = {
  buttons?: Array<IButton>;
  value: TValue;
  onChange: (value: TValue) => void;
  label?: TLabel;
  className?: any;
};

export const BaseButtonGroup: React.FC<PBaseButtonGroup> = (props) => {
  const {
    onChange,
    value,
    label,
    buttons = [
      { value: true, label: 'Yes' },
      { value: false, label: 'No' },
    ],
    className,
    ...otherProps
  } = props;
  return (
    <div className={clsx(className)}>
      {label && (
        <BaseTypography variant="caption" style={{ marginBottom: '8px' }}>
          {label}
        </BaseTypography>
      )}
      <ButtonGroup {...otherProps}>
        {buttons.map((btn: IButton) => {
          const btnVariant = value === btn.value ? 'contained' : 'outlined';
          return (
            <BaseButton
              key={btn.value}
              variant={btnVariant}
              color={btnVariant === 'contained' ? 'primary' : 'default'}
              onClick={() => onChange(btn.value)}
            >
              {btn.label}
            </BaseButton>
          );
        })}
      </ButtonGroup>
    </div>
  );
};
